'use strict';

import 'angular';

import addDirective from './add';
import editDirective from './update';
import deleteDirective from './delete';
import moveDirective from './move';
import reinstateDirective from './reinstate';
import resetPasswordModule from './reset-password';
import nameCircleDirective from './components/name-circle';
import userSelect from './components/user-select';
import codeModule from './code';
import optionsService from './options/options-service';
import optionsCtrl from './options/options-ctrl';
import switchWatcher from './components/switch-watcher'

const MODULE_NAME = 'daupler.users';

var app = angular.module(MODULE_NAME, [
	resetPasswordModule,
	codeModule,
	'brg.components.inputs',
	'ui.mask',
]);
app.service('userOptions', optionsService);
app.controller('UserOptions', optionsCtrl);
app.directive('addUser', addDirective);
app.directive('editUser', editDirective);
app.directive('deleteUser', deleteDirective);
app.directive('moveUser', moveDirective);
app.directive('reinstateUser', reinstateDirective);
app.directive('nameCircle', nameCircleDirective);
app.directive('userSelect', userSelect);
app.directive('switchWatcher', switchWatcher);

export default MODULE_NAME;
